import setHospitalSelectors from './setHospitalSelectors';
import setHospitalCounters from './setHospitalCounters';
import setHospitalEvents from './setHospitalEvents';
import setMoreHospitalEvents from './setMoreHospitalEvents';
import setHospitalDetails from './setHospitalDetails';
import clearHospitalDetails from './clearHospitalDetails';
import reset from './reset';

export default {
  setHospitalSelectors,
  setHospitalCounters,
  setHospitalEvents,
  setMoreHospitalEvents,
  setHospitalDetails,
  clearHospitalDetails,
  reset,
};
